// extracted by mini-css-extract-plugin
export default {"body":"warehouse_body__bSOqX","topbar":"warehouse_topbar__wxQBv","strong":"warehouse_strong__qSs32"};